// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_style_header__2tydw","title":"Header_style_title__2w2kx","content":"Header_style_content__2Fc5Q"};